import { Vue, Component, Prop } from 'vue-property-decorator';

@Component
export default class Search extends Vue {
    @Prop() readonly index!: number;
    get getFieldColor() {
        return this.index % 2 ? 'alternative-grey' : '';
    }
}
